import {Box, Typography, Stack} from '@mui/material'
import {styled} from '@mui/system'

const LegendContainer = styled(Box)(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: '4px 12px',
  borderRadius: 8,
  border: '1px solid #eeeeee',
  backgroundColor: '#fafafa',
}))

const LegendLabel = styled(Typography)({
  fontSize: '0.68rem',
  fontWeight: 600,
  color: '#637381',
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
})

const LegendItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
})

const LegendDot = styled(Box, {
  shouldForwardProp: (p) => p !== 'bg',
})(({bg}) => ({
  width: 8,
  height: 8,
  borderRadius: 2,
  backgroundColor: bg,
}))

const LegendText = styled(Typography)({
  fontSize: '0.65rem',
  color: '#637381',
  fontWeight: 500,
})

export const PerformanceLegend = () => {
  return (
    <LegendContainer>
      <LegendLabel>Performance:</LegendLabel>
      <LegendItem>
        <LegendDot bg='#10b981' />
        <LegendText>{'>93%'}</LegendText>
      </LegendItem>
      <LegendItem>
        <LegendDot bg='#f59e0b' />
        <LegendText>85–93%</LegendText>
      </LegendItem>
      <LegendItem>
        <LegendDot bg='#ef4444' />
        <LegendText>75–83%</LegendText>
      </LegendItem>
      <LegendItem>
        <LegendDot bg='#991b1b' />
        <LegendText>{'<75%'}</LegendText>
      </LegendItem>
    </LegendContainer>
  )
}
